module.exports = __webpack_public_path__ + "img/collective-account.38117bcc.svg";